import type { ChatHandlerConfig } from './types';
import { ensureInlineCodeCopyDelegation, copyText } from './clipboard';
import { configureChatHandlers } from './context';
import { setupMarkdownRendering } from './markdown';

export function setupChatHandlers(handlers: ChatHandlerConfig): void {
  configureChatHandlers(handlers);
  setupMarkdownRendering();
  ensureInlineCodeCopyDelegation();
}

export { copyText };
export { clearPreviewCode, renderMarkdown } from './markdown';
export { incrementRenderEpoch } from './render-epoch';
export {
  startGenerating,
  startNextStreamingTurn,
  ensureStreamingPlaceholderVisible,
  finishGenerating,
  scheduleRender,
  flushRender,
  renderStreamingSegments,
  updateStreamingAssistantMeta,
  markStreamingProcessTextSegments,
} from './streaming';
export { renderMessages } from './message-renderer';
export { prependHistoryMessages } from './history';
export { appendToolCall, updateToolCall } from './tool-calls';
export { appendUserMessage } from './message-element';
export { appendSystemMessage, appendError } from './errors';
export { scrollToBottom, updateScrollbar, setupScrollbar } from './scrollbar';
